import useCheckFrdsGoftino from "@shared/components/chat-setting/useCheckFrdsGoftino";
import { useGoftino } from "@shared/components/chat-setting/useGoftino";
import { useEffect } from "react";

export type GOFTINO_MODE = "all" | "mobile" | "desktop" | "none";

const useRenderGoftino = (mode: GOFTINO_MODE = "desktop", offset?: number) => {
  const { showGoftino, initialGoftino, hideGoftino } = useGoftino();
  const { showChatFrds, initialChatFrds, isFrdsChat } = useCheckFrdsGoftino();

  useEffect(() => {
    const isMobile = window.innerWidth < 768;

    const addGoftionHandler = () => {
      if (!isFrdsChat) showGoftino();
      showChatFrds(offset);
    };

    if (mode === "none") return hideGoftino();

    const shouldRender =
      mode === "all" || (isMobile ? mode === "mobile" : mode === "desktop");
    if (shouldRender) addGoftionHandler();
    else hideGoftino();

    () => {
      initialGoftino(false);
      initialChatFrds();
    };
  }, []);
};

export default useRenderGoftino;
